module.exports = __webpack_public_path__ + "static/img/partner_IV.aff577c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/partner_IV.png
// module id = 06rZ
// module chunks = 9